import { useIsServerSideRendering } from '@dbh/environment';
import { useMakeSelect } from '@dbh/reselect-extra';
import LoadingView from '@dbh/loading-view';
import { jsx } from 'react/jsx-runtime';
import { createSelector } from 'reselect';
import { makeSelectWebcontrolsLoaded } from '@dbh/webcontrols-redux';
import { makeSelectTemplateCode } from '@dbh/webpages-redux';
import 'prop-types';
import { PAGE_TYPES } from '@dbh/admindev-constants';
import '@dbh/admindev-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { makeSelectPreviousLocationPathname, makeSelectLocationPathname } from '@dbh/routing-redux';

/**
 * Returns `true` if we are currently in a page transition, `false` otherwise.
 * @param {string?} webpagesTemplateCode `PAGE_TYPE` that indicates the template
 * code as returned from the `API`.
 * It is `undefined` if we are fetching the data.
 * @param {boolean?} webcontrolsLoaded Are the `webcontrols` downloaded for the
 * current `routerPageType`.
 * @param {string} routerPageType The `PAGE_TYPE` given the current `URL`.
 * @return {boolean} Are we currently in a page transition.
 */const isPageTransitionCompleted=withConformsTo("isPageTransitionCompleted",[],(a,b,c)=>{const d=(c===a||a===PAGE_TYPES.NotFoundPage)&&b;return d});var isPageTransitionCompleted$1 = isPageTransitionCompleted;

// The second capturing group matches a numeric sequence and an optional
// trailing slash.
const REGEX_EXTRACT_PATHNAME=/(.*?)\/?(\d+\/?)?$/,arePathnamesPaginated=withConformsTo("arePathnamesPaginated",[],(a,b)=>{// First page after server side rendering in the browser, or render in server
// side rendering.
if(!a)return !1;const c=REGEX_EXTRACT_PATHNAME.exec(a);if(!c)return !1;const d=REGEX_EXTRACT_PATHNAME.exec(b);if(!d)return !1;const[,e,f]=c,[,g,h]=d;// We don't want this "global" loading spinner to show up in the paginated
// pages such as the `SearchResultsPage`, since we use a custom spinner there.
return e===g&&(!!f||!!h)});/**
 * Given 2 pathnames returns `true` if they have a common root (followed by an
 * optional paginated part).
 * @param {string?} prevPathname Previous location pathname.
 * @param {string} currentPathname Current location pathname.
 * @return {boolean} Do they have a common `substring`.
 */var arePathnamesPaginated$1 = arePathnamesPaginated;

/**
 * Returns a selector that returns `true` if the page transition is completed.
 * @return {boolean} `true` if page transition is completed, false otherwise.
 */const makeSelectIsPageTransitionComplete=()=>createSelector(makeSelectTemplateCode(),makeSelectWebcontrolsLoaded(),(a,b)=>c=>isPageTransitionCompleted$1(a,b,c));var makeSelectIsPageTransitionComplete$1 = makeSelectIsPageTransitionComplete;

/**
 * Returns a selector that returns `true` if the page transition is between
 * paginated pages.
 * @return {boolean} `true` if previous and current `pathname` have a common root
 * followed by "an pagination part if it exists".
 */const makeSelectIsPaginationPageTransition=()=>createSelector(makeSelectPreviousLocationPathname(),makeSelectLocationPathname(),arePathnamesPaginated$1);var makeSelectIsPaginationPageTransition$1 = makeSelectIsPaginationPageTransition;

const PageScaffolding=a=>{let{routerPageType:b,children:c,...d}=a;const e=useMakeSelect(makeSelectIsPageTransitionComplete$1),f=useMakeSelect(makeSelectIsPaginationPageTransition$1),g=useIsServerSideRendering();return g||f||e(b)?c:/*#__PURE__*/jsx(LoadingView,{...d});// Browsers only.
};PageScaffolding.displayName="PageScaffolding";

export { PageScaffolding as default };
